export default __webpack_public_path__ + "static/media/polgo-screenshot-05.64fab0c9.png";